const SvgSpotdraft = (props) => (
  <svg
    width={18}
    height={18}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M14.7515 8.03151H11.9946L14.8354 1.15499C14.9088 0.966304 14.7829 0.798584 14.6152 0.798584H9.00711C8.94421 0.798584 8.8813 0.819552 8.8289 0.851C8.8289 0.851 6.78481 2.57013 6.14538 3.11522C6.072 3.17812 6.03007 3.24101 5.98814 3.33535C5.66318 4.15299 3.02159 10.5159 3.02159 10.5159C2.93773 10.7465 3.11593 10.8618 3.2522 10.8618H6.82674L4.78265 15.8829L4.38431 16.8578C4.28997 17.0989 4.573 17.3085 4.77217 17.1408C4.77217 17.1408 14.6152 8.70242 14.9088 8.4613C15.066 8.32503 15.0241 8.01055 14.7515 8.01055V8.03151ZM10.4118 7.06711L10.0449 7.94765C10.0449 7.94765 9.97151 8.03151 9.91906 8.03151H6.12441C6.072 8.03151 6.03007 7.96865 6.05103 7.9267L6.41792 7.04616C6.41792 7.04616 6.4913 6.9623 6.54371 6.9623H10.3489C10.4013 6.9623 10.4432 7.01471 10.4223 7.06711H10.4118ZM11.4915 4.46746L11.1246 5.34799C11.1246 5.34799 11.0512 5.43185 10.9988 5.43185H7.20413C7.15168 5.43185 7.10977 5.37944 7.13073 5.32703L7.49761 4.4465C7.49761 4.4465 7.57102 4.36264 7.62342 4.36264H11.4286C11.481 4.36264 11.5229 4.41505 11.5019 4.46746H11.4915Z"
      fill="#3259E4"
    />
  </svg>
);
export default SvgSpotdraft;
